import { distinctUntilChanged, Observable, ReplaySubject } from 'rxjs';

import { Injectable } from '@angular/core';
import { SaveObjectInLocalServiceService } from './save-object-in-local-service.service';

@Injectable({
  providedIn: 'root'
})
export class RolePermissionsService {
  currentPermissions: Observable<string[]>;
  private readonly currentPermissionsSubject = new ReplaySubject<string[]>(1);

  constructor(private readonly storage: SaveObjectInLocalServiceService) {
    this.currentPermissions = this.currentPermissionsSubject.asObservable().pipe(distinctUntilChanged());
    this.currentPermissions = this.currentPermissionsSubject.asObservable().pipe(distinctUntilChanged());
  }

  /**
   * Asigna y guarda en memoria las rutas de acceso y permisos del usuario logueado.
   *
   * @param permissions - Permisos general del usuario logueado
   */
  setPermissions(permissions: string[]): void {
    this.currentPermissionsSubject.next(permissions);
  }

  getPermissions() {
    return this.currentPermissionsSubject.asObservable();
  }

  hasPermission(...permissions: string[]): boolean {
    let hasPermission: boolean = false;
    let userPermissionsConverted: string[] = [];
    let userPermissions = this.storage.getObject('permissions');
    userPermissions = userPermissions.replace(/&#34;/g, '"');
    userPermissionsConverted = JSON.parse(userPermissions) as string[];

    if (userPermissionsConverted.length > 0) {
      hasPermission = permissions.some((p) => userPermissionsConverted.includes(p));
    }

    return hasPermission;
  }
}
